import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import ar from './locales/ar.json';

const LANG_KEY = 'shreeksakn-lang';

const savedLang = localStorage.getItem(LANG_KEY) || 'en';

function humanizeMissingKey(key: string) {
  const leaf = String(key || '').split('.').filter(Boolean).pop() || '';
  if (!leaf) return '';
  return leaf
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/^./, (char) => char.toUpperCase());
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ar: { translation: ar },
  },
  lng: savedLang,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  returnNull: false,
  returnEmptyString: false,
  parseMissingKeyHandler: humanizeMissingKey,
});

// Persist language changes
i18n.on('languageChanged', (lng) => {
  localStorage.setItem(LANG_KEY, lng);
  document.documentElement.lang = lng;
  document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
});

// Set initial direction
document.documentElement.lang = savedLang;
document.documentElement.dir = savedLang === 'ar' ? 'rtl' : 'ltr';

// Expose the i18n instance on window in dev/test builds so Playwright specs
// can verify translation contracts directly (e.g. that "Roomaty path"-style
// strings are not present in any locale). Stripped in prod by Vite's
// import.meta.env check.
if ((import.meta as any).env?.DEV) {
  (window as any).i18next = i18n;
}

export default i18n;
